import React from "react";
import "./Footer.css";
import Logo from "./Logo";
import { Link } from "react-router-dom";
import {
  FaWhatsapp, FaFacebookF, FaInstagram, FaTwitter,
  FaMapMarkerAlt, FaPhoneAlt, FaEnvelope,
} from "react-icons/fa";
import { FaX } from "react-icons/fa6";
import { LuShieldCheck, LuMessageCircle, LuCloudUpload } from "react-icons/lu";

const CATEGORIES = [
  { label: "Electronics",        slug: "electronics"           },
  { label: "Vehicles",           slug: "vehicles"              },
  { label: "Property",           slug: "property"              },
  { label: "Fashion & Beauty",   slug: "fashion-beauty"        },
  { label: "Services",           slug: "services"              },
  { label: "Jobs",               slug: "jobs"                  },
  { label: "Home & Furniture",   slug: "home-furniture"        },
  { label: "Gadgets",            slug: "gadgets-accessories"   },
];

const FEATURES = [
  {
    Icon: LuShieldCheck,
    title: "TrovePay Escrow Protection",
    body: "Payments are held safely with TrovePay until you receive, inspect, and confirm your purchase.",
    highlight: true,
  },
  {
    Icon: LuMessageCircle,
    title: "Direct Seller Chat",
    body: "Chat directly with sellers and dealers via in-app messenger or WhatsApp.",
  },
  {
    Icon: LuCloudUpload,
    title: "Easy Ad Posting",
    body: "Take photos, add your price, and post your ad in under two minutes with TrovePay warranty.",
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">

      {/* ── Features strip ── */}
      <div className="footer-features">
        <div className="footer-features-inner container">
          {FEATURES.map(({ Icon, title, body, highlight }) => (
            <div className="ff-item" key={title}>
              <span className={`ff-icon${highlight ? " ff-icon--hl" : ""}`} aria-hidden="true">
                <Icon size={26} />
              </span>
              <div className="ff-text">
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Main ── */}
      <div className="footer-main">
        <div className="footer-inner container">

          {/* Brand column */}
          <div className="footer-col footer-brand">
            <Logo variant="onDark" className="footer-logo" />
            <p className="footer-desc">
              TroveHub (trovehub.ng) is Nigeria's safest online marketplace —
              connecting buyers and sellers across all 36 states with
              TrovePay escrow protection. Safe. Simple. Local.
            </p>
            <div className="footer-contact">
              <div className="fc-item">
                <FaPhoneAlt className="fc-icon" />
                <a href="tel:+2349034808095">+234 903 480 8095</a>
              </div>
              <div className="fc-item">
                <FaEnvelope className="fc-icon" />
                <a href="mailto:hello@trovehub.ng">info@trovehub.ng</a>
              </div>
              <div className="fc-item">
                <FaMapMarkerAlt className="fc-icon" />
                <span>Enugu, Nigeria</span>
              </div>
            </div>
            <div className="footer-social">
              <a href="https://wa.me/+2349034808095" target="_blank" rel="noopener noreferrer" className="social-btn whatsapp"><FaWhatsapp /></a>
              <a href="#!" className="social-btn facebook"><FaFacebookF /></a>
              <a href="#!" className="social-btn instagram"><FaInstagram /></a>
              <a href="#!" className="social-btn twitter"><FaX/></a>
            </div>
          </div>

          {/* Categories */}
          <div className="footer-col">
            <h4 className="footer-col-title">Categories</h4>
            <ul className="footer-links">
              {CATEGORIES.map(c => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`}>{c.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/all">All Listings</Link></li>
              <li><Link to="/login">Login / Register</Link></li>
              <li><Link to="/dashboard">My Account</Link></li>
              <li><Link to="/dashboard/escrow">TrovePay Escrow</Link></li>
              <li><Link to="/dashboard/post">Post a Free Ad</Link></li>
              <li><Link to="/companies">Stores</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div className="footer-col">
            <h4 className="footer-col-title">Information</h4>
            <ul className="footer-links">
              <li><Link to="/about">About TroveHub</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/trovepay">TrovePay (Escrow)</Link></li>
              <li><Link to="/safety-tips">Safety Tips</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

        </div>
      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner container">
          <p className="footer-copy">
            © {year} TroveHub Digital Services Ltd · trovehub.ng · RC 0000000 · All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>

    </footer>
  );
}